export default __webpack_public_path__ + "static/media/service_2.59716f6f.jpg";